import { render, staticRenderFns } from "./card-feature.vue?vue&type=template&id=4a1b8eca&scoped=true&"
import script from "./card-feature.vue?vue&type=script&lang=js&"
export * from "./card-feature.vue?vue&type=script&lang=js&"
import style0 from "./card-feature.vue?vue&type=style&index=0&id=4a1b8eca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1b8eca",
  null
  
)

export default component.exports